export const state = {
    keyword: '',
}

export const getters = {}

export const mutations = {
    UPDATE_KEYWORD(state, keyword) {
        // Normalize input - accept either format (spaces or underscores)
        state.keyword = (keyword || '').replace(/_/g, ' ').trim()
    },
}

export const actions = {}
